// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const get = require('lodash/object/get');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');

// @ components
const { MortgageRequestCoHolderRNC } = require('components/mortgageRequest/mortgageRequestCoHolderRNC/mortgageRequestCoHolderRNC');

// @ actions
const dataProprietorActions = require('actions/mortgageRequest/mortgageRequestDataProprietor');
const getHolderActions = require('actions/mortgageRequest/mortgageRequestHolder');

class MortgageRequestCoHolderRNCView extends React.Component {
    constructor(props) {
        super(props);

        this.propietor = {};
        this.filterPropietor = this.filterPropietor.bind(this);
    }

    componentWillMount() {
        const { dataPropietorState, requestDataProprietor } = this.props;
        if (!dataPropietorState.get('data', []).count()) {
            requestDataProprietor();
        } else {
            this.propietor = this.filterPropietor(this.props);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { dataPropietorState, requestHolder } = nextProps;
        if (dataPropietorState.get('data', []).count()) {
            this.propietor = this.filterPropietor(nextProps);
            const { tipoDocumentoIdentidad, identificador } = get(this.propietor, 'datosPersonales.documentoDeIdentidad', {});
            const holderId = `${tipoDocumentoIdentidad}-${identificador}`;
            requestHolder(holderId);
        }
    }

    filterPropietor(props) {
        const { dataPropietorState } = props;
        const dataPropietorInfoObject = dataPropietorState.get('data').toJS();
        const dataPropietorInfo = dataPropietorInfoObject.filter(
            x => x.numeroTitular === 1
        );
        if (dataPropietorInfo.length) {
            return dataPropietorInfo[0];
        }
        return {};
    }

    render() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestCoHolder-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        return (
            <div className="mortgage-request-co-holder-rnc-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestCoHolder-titleHeader')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-8 col-xs-offset-2">
                                <ContentBox hasShadow={false}>
                                    <MortgageRequestCoHolderRNC
                                        isClientWithoutAccounts={isClientWithoutAccounts} />
                                </ContentBox>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestCoHolderRNCView.propTypes = {
    match: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    requestDataProprietor: PropTypes.func,
    dataPropietorState: PropTypes.object,
    requestHolder: PropTypes.func
};

module.exports.MortgageRequestCoHolderRNCView = MortgageRequestCoHolderRNCView;
module.exports.MortgageRequestCoHolderRNCView = connect(
    state => ({
        dataPropietorState: state.mortgageRequestDataProprietor,
        immGlobalPosition: state.globalPosition,
    }), {
        requestHolder: getHolderActions.requestHolder,
        requestDataProprietor: dataProprietorActions.requestDataProprietor
    })(MortgageRequestCoHolderRNCView);
